import React from 'react'

import { Box, Button, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { LockOutlined } from '@material-ui/icons'

import useAuth from '~/utils/auth/useAuth'

const useStyle = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    padding: theme.spacing(4),
    backgroundColor: theme.palette.background.default,
  },
  icon: {
    fontSize: 72,
    color: theme.palette.text.disabled,
    marginBottom: theme.spacing(3),
  },
  title: {
    fontWeight: 700,
    marginBottom: theme.spacing(2),
    color: theme.palette.text.primary,
  },
  subtitle: {
    color: theme.palette.text.secondary,
    textAlign: 'center',
    maxWidth: 480,
    marginBottom: theme.spacing(4),
    lineHeight: 1.6,
  },
}))

const NoPermissionPage = () => {
  const classes = useStyle()
  const { handleLogout } = useAuth()

  return (
    <Box className={classes.container}>
      <LockOutlined className={classes.icon} />
      <Typography variant="h5" className={classes.title}>
        No Access
      </Typography>
      <Typography variant="body1" className={classes.subtitle}>
        Your account does not have any assigned roles or permissions to access
        this application. Please contact your administrator to set up the
        appropriate role and permissions for your account.
      </Typography>
      <Button variant="outlined" color="secondary" onClick={handleLogout}>
        Back to Login
      </Button>
    </Box>
  )
}

export default NoPermissionPage
